import { readUnhandledEnumCase } from 'rpc-client-utils';
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ACThumbnailOverlay from 'academy-common-lib/components/card/ACThumbnailOverlay';
import { getDisplayCategories } from 'academy-common-lib/utils/categories';
import { VideoWatermarkCTA } from './VideoWatermarkCTA';
import { useLessonProgressById } from '../../userProgress/userProgressQueries';
import { useLesson, useShorts } from '../../../hooks/contentHooks';
import { jsx as _jsx } from "react/jsx-runtime";
const VideoProgressOverlay = ({
  contentId,
  hasLearnByDoing,
  isPublic = false,
  learnByDoingHref,
  lessonId,
  shortId,
  link,
  openLinksInNewTab,
  renderContext = 'embedded-academy',
  onWatermarkClick
}) => {
  var _lessonProgressById$c, _lesson$content, _ref, _lessonCategories$sli, _ref2, _content$duration;
  const {
    lessonProgressById
  } = useLessonProgressById(lessonId, isPublic);
  const {
    lesson
  } = useLesson(lessonId, isPublic);
  const {
    shortFormContent
  } = useShorts(shortId, isPublic);
  const contentProgress = lessonProgressById === null || lessonProgressById === void 0 || (_lessonProgressById$c = lessonProgressById.contentProgress) === null || _lessonProgressById$c === void 0 ? void 0 : _lessonProgressById$c.find(content => content.contentId === contentId);
  const content = lesson === null || lesson === void 0 || (_lesson$content = lesson.content) === null || _lesson$content === void 0 ? void 0 : _lesson$content.find(c => c.id === contentId);
  const lessonCategories = lesson ? lesson.subCategories.map(readUnhandledEnumCase) : undefined;
  const shortFormContentCategories = shortFormContent === null || shortFormContent === void 0 ? void 0 : shortFormContent.subCategories.map(readUnhandledEnumCase);
  const categories = getDisplayCategories((_ref = (_lessonCategories$sli = lessonCategories === null || lessonCategories === void 0 ? void 0 : lessonCategories.slice(0, 1)) !== null && _lessonCategories$sli !== void 0 ? _lessonCategories$sli : shortFormContentCategories === null || shortFormContentCategories === void 0 ? void 0 : shortFormContentCategories.slice(0, 1)) !== null && _ref !== void 0 ? _ref : []);
  const completed = (contentProgress === null || contentProgress === void 0 ? void 0 : contentProgress.progressType) === 'COMPLETED';
  // @ts-expect-error typescript@5.7.3 stricter checks
  const duration = (_ref2 = (_content$duration = content === null || content === void 0 ? void 0 : content.duration) !== null && _content$duration !== void 0 ? _content$duration : shortFormContent === null || shortFormContent === void 0 ? void 0 : shortFormContent.duration) !== null && _ref2 !== void 0 ? _ref2 : 0;
  return /*#__PURE__*/_jsx(ACThumbnailOverlay, {
    categories: categories,
    completed: completed,
    contentType: "ACADEMY_VIDEO",
    contentTypeName: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyAiPrompt.hubSpotAcademyVideo"
    }),
    duration: 1,
    footer: !completed && /*#__PURE__*/_jsx(FormattedDuration, {
      from: Date.now() - duration * 1000,
      to: Date.now(),
      type: "portalTz"
    }),
    remainingTime: completed ? 1 : 0,
    watermark: /*#__PURE__*/_jsx(VideoWatermarkCTA, {
      contentId: contentId,
      hasLearnByDoing: hasLearnByDoing,
      learnByDoingHref: learnByDoingHref,
      lessonId: lessonId,
      link: link,
      onClick: onWatermarkClick,
      openLinksInNewTab: openLinksInNewTab,
      renderContext: renderContext,
      shortId: shortId,
      trackAction: hasLearnByDoing ? 'watermark-learn-by-doing-click' : 'watermark-link-to-academy-click'
    })
  });
};
export default VideoProgressOverlay;